import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import communityGardenBeneficiaryListAction from './communityGardenBeneficiaryList.action.json' with { type: 'json' }
import { communityGardenBeneficiaryObject } from '../../communityGarden/communityGardenBeneficiaryObject'

export const communityGardenBeneficiaryExpression = expression(
  communityGardenBeneficiaryObject.shape,
)

const communityGardenBeneficiaryListDefinition = defineAction({
  ...communityGardenBeneficiaryListAction,

  input: z.object({
    filter: communityGardenBeneficiaryExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      id: 'Identificador',
      communityGardenId: 'Horta',
      citizenId: 'Cidadão',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({ items: z.array(communityGardenBeneficiaryObject), count: z.number() }),
})

export default communityGardenBeneficiaryListDefinition
